(function () {
  var TYPE_POS = 1;
  var SIZE_POS = 2;
  var LENGTH_POS = 3;
  var DEFAULT = "Default";

  function swatchRoot() {
    return document.querySelector("swatch-component");
  }

  function groupEl(root, position) {
    var inner = root.querySelector('.js-swatch-item[data-position="' + position + '"]');
    return inner ? inner.closest(".swatch-group") : null;
  }

  function currentType(root) {
    var typeGroup = root.querySelector('.js-swatch-item[data-position="' + TYPE_POS + '"]');
    if (!typeGroup) return "";
    if (typeGroup.dataset.style === "select") {
      var sel = typeGroup.querySelector("select.js-option-item");
      return sel ? sel.value : "";
    }
    var checked = typeGroup.querySelector(".js-option-item:checked");
    return checked ? checked.value : "";
  }

  function selectValue(root, position, value) {
    var group = root.querySelector('.js-swatch-item[data-position="' + position + '"]');
    if (!group) return;
    if (group.dataset.style === "select") {
      var sel = group.querySelector("select.js-option-item");
      if (!sel) return;
      sel.value = value;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    var input = Array.prototype.find.call(
      group.querySelectorAll(".js-option-item"),
      function (el) {
        return el.value === value;
      }
    );
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setSizeLengthVisible(root, visible) {
    [SIZE_POS, LENGTH_POS].forEach(function (pos) {
      var g = groupEl(root, pos);
      if (!g) return;
      if (visible) g.classList.remove("d-none");
      else g.classList.add("d-none");
    });
  }

  function setDefaultOptionsVisible(root, visible) {
    [SIZE_POS, LENGTH_POS].forEach(function (pos) {
      var group = root.querySelector('.js-swatch-item[data-position="' + pos + '"]');
      if (!group) return;
      if (group.dataset.style === "select") {
        var sel = group.querySelector("select.js-option-item");
        if (!sel) return;
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (/^default$/i.test(opt.value)) {
            opt.hidden = !visible;
            opt.disabled = !visible;
          }
        });
        return;
      }
      Array.prototype.forEach.call(group.querySelectorAll(".js-option-item"), function (input) {
        if (!/^default$/i.test(input.value)) return;
        var wrap = input.closest(".swatch-group_wrapper") || input.closest(".input-group") || input;
        if (visible) {
          wrap.classList.remove("d-none");
          wrap.style.display = "";
        } else {
          wrap.classList.add("d-none");
          wrap.style.display = "none";
        }
      });
    });
  }

  function firstNonDefault(root, position) {
    var group = root.querySelector('.js-swatch-item[data-position="' + position + '"]');
    if (!group) return null;
    if (group.dataset.style === "select") {
      var sel = group.querySelector("select.js-option-item");
      if (!sel) return null;
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (!o.disabled && !o.hidden && !/^default$/i.test(o.value)) return o.value;
      }
      return null;
    }
    var input = Array.prototype.find.call(group.querySelectorAll(".js-option-item"), function (el) {
      return !/^default$/i.test(el.value) && !el.disabled;
    });
    return input ? input.value : null;
  }

  function ensureNonDefaultSelected(root, position) {
    var group = root.querySelector('.js-swatch-item[data-position="' + position + '"]');
    if (!group) return;
    var current = "";
    if (group.dataset.style === "select") {
      var sel = group.querySelector("select.js-option-item");
      current = sel ? sel.value : "";
    } else {
      var checked = group.querySelector(".js-option-item:checked");
      current = checked ? checked.value : "";
    }
    if (!/^default$/i.test(current) && current) return;
    var next = firstNonDefault(root, position);
    if (next) selectValue(root, position, next);
  }

  function apply() {
    var root = swatchRoot();
    if (!root) return;
    var type = currentType(root);
    if (/^unstitched$/i.test(type)) {
      setDefaultOptionsVisible(root, true);
      selectValue(root, SIZE_POS, DEFAULT);
      selectValue(root, LENGTH_POS, DEFAULT);
      setSizeLengthVisible(root, false);
    } else if (/^stitched$/i.test(type)) {
      setSizeLengthVisible(root, true);
      setDefaultOptionsVisible(root, false);
      ensureNonDefaultSelected(root, SIZE_POS);
      ensureNonDefaultSelected(root, LENGTH_POS);
    }
  }

  function bind() {
    var root = swatchRoot();
    if (!root || root.dataset.acUnstitchBound) return;
    root.dataset.acUnstitchBound = "1";
    root.addEventListener("change", function (e) {
      if (!e.target || !e.target.classList.contains("js-option-item")) return;
      var pos = e.target.getAttribute("data-option-position");
      if (pos === "1" || e.target.name === "option1") {
        apply();
      }
    });
    root.addEventListener("swatch-change", function (e) {
      if (e.detail && Number(e.detail.position) === 1) apply();
    });
    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", bind);
  setTimeout(bind, 500);
})();